import { render, staticRenderFns } from "./JobCustomer.vue?vue&type=template&id=6883a9c6"
import script from "./JobCustomer.vue?vue&type=script&lang=js"
export * from "./JobCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports